module.exports = __webpack_public_path__ + "img/MemeETC (17).6b4509b1.jpeg";